export default {
  navigationBarTitleText: intl.get('fileMoveTo.title')
};
